import * as moment from 'moment';
import {NgbDate, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {UkDateFullYearFormat} from '../../../common/date-format.constants';


/**
 * TODO - this code is shit because it uses Date.  Date library is a Piece of Shit, use moment
 *  all these will fail tests when we are changing timezone.
 * */

export class DatePickerUtil {

  static getLastSaturdayNgbDate(): NgbDateStruct {
    const d = this.getLastSaturday();
    return {'year': d.getFullYear(), 'month': d.getMonth() + 1, 'day': d.getDate()};
  }

  static getLastSundayNgbDate(): NgbDateStruct {
    const d = this.getLastSunday();
    return {'year': d.getFullYear(), 'month': d.getMonth() + 1, 'day': d.getDate()};
  }

  static getLastSaturday(): Date {
    const d = new Date();
    d.setDate(d.getDate() - ((d.getDay() === 6) ? 7 : d.getDay() + 1));
    return d;
  }

  static getLastSunday(): Date {
    const d = new Date();
    d.setDate(d.getDate() - ((d.getDay() === 0) ? 7 : d.getDay()));
    return d;
  }

  static getLastSaturdayString(format: string): string {
    return moment(this.getLastSaturday()).utc(true).format(format);
  }

  static getLastSundayString(format: string): string {
    return moment(this.getLastSunday()).utc(true).format(format);
  }

  static isSaturday(date: NgbDateStruct): boolean {
    const d = new Date(date.year, date.month - 1, date.day);
    return d.getDay() === 6;
  }

  static isSunday(date: NgbDateStruct): boolean {
    const d = new Date(date.year, date.month - 1, date.day);
    return d.getDay() === 0;
  }

  static getNgbDateStructFromDateString(dateString: string, format: string): NgbDateStruct {
    const date = moment.utc(dateString, format);
    return {
      year: date.year(),
      month: date.month() + 1,
      day: date.date()
    };
  }

  static getNgbDateStructFromDate(date: Date): NgbDateStruct {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  static getNgbUkDateStructFromDate(value: string): NgbDateStruct {
    const date = moment(value, UkDateFullYearFormat);
    return {
      day: date.date(),
      month: date.month() + 1,
      year: date.year()
    };
  }

  static getDateStringFromNgbDate(date: NgbDate, format: string): string {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    return moment(jsDate).format(format);
  }

  static getYesterdayDate(): Date {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d;
  }

  static getFirstDayFourYearsAgoNgbDate(): NgbDateStruct {
    const d = new Date();
    return {year: d.getFullYear() - 4, month: 1, day: 1};
  }

  static getThreeMonthsFromTodayToSaturdayNgbDate(): NgbDateStruct {
    const threeMonthsFromToday = moment().add(3, 'months');

    const currentDay = threeMonthsFromToday.day();
    const date = currentDay === 6
      ? threeMonthsFromToday
      : threeMonthsFromToday.day(currentDay < 6 ? 6 : 6 + 7);

    return { year: date.year(), month: date.month() + 1, day: date.date() };
  }
}
